import { render } from "./operatelog.vue?vue&type=template&id=c3fd70be"
import script from "./operatelog.vue?vue&type=script&lang=js"
export * from "./operatelog.vue?vue&type=script&lang=js"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__